import { MessageCircle } from "lucide-react";
import { supportCopy } from "./copy";
import "./support.css";
export function SupportEntry(): React.JSX.Element | null {
  if (
    window.location.pathname === "/support" ||
    window.location.hostname.startsWith("admin.")
  )
    return null;
  const locale = new URLSearchParams(window.location.search).get("lang"),
    key =
      locale === "ko" ? "ko" : locale === "th" || locale === null ? "th" : "en";
  return (
    <a className="db-support-entry" href={`/support?lang=${key}`}>
      <MessageCircle size={19} />
      {supportCopy[key].title}
    </a>
  );
}
